import React from 'react'

import {
  HouseOptionsGlobalForm,
  HouseOptionsGlobalFormProps,
} from './global/HouseOptionsGlobalForm'
import {
  HouseOptionsIndividualForm,
  HouseOptionsIndividualFormProps,
} from './individual/HouseOptionsIndividualForm'
import { HouseContext } from '../../../lib/graphql'

export type HouseOptionsFormLayoutProps = HouseOptionsFormProps & {
  isOpen: boolean
  handleOnExpand: () => void
  layoutProps: {
    parentHeight: number | undefined
    numberOfCards: number
  }
}

export type HouseOptionsFormProps = {
  house: Pick<
    HouseContext,
    'priceType' | 'houseType' | 'options' | 'currencyArea'
  >
  isDisabled?: boolean
}
export const HouseOptionsForm = (
  props: HouseOptionsFormProps &
    HouseOptionsIndividualFormProps &
    HouseOptionsGlobalFormProps,
) => {
  const {
    house: { options },
  } = props

  return (
    <>
      {options.__typename === 'HouseOptionsGlobal' ? (
        <HouseOptionsGlobalForm {...props} />
      ) : (
        <HouseOptionsIndividualForm {...props} />
      )}
    </>
  )
}
